const TokenKey = 'token'
import store from '../store'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeData() {
  store.commit('user/SET_USERINFO', {})
  localStorage.removeItem(TokenKey)
  sessionStorage.clear()
}
